module.exports = __webpack_public_path__ + "img/secC.4729624c.png";